var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.2044V18.8925C4.5 19.4514 4.71071 19.9875 5.08579 20.3827C5.46086 20.778 5.96957 21 6.5 21H18.5C19.0304 21 19.5391 20.778 19.9142 20.3827C20.2893 19.9875 20.5 19.4514 20.5 18.8925V15.2044M12.5007 14.9425L12.5007 3M12.5007 3L7.92931 7.56318M12.5007 3L17.0722 7.56318",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.96aa3072b15b1ac9b8a3a8dee1d900c4.svg";
export { ForwardRef as ReactComponent };